import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'svg[mib-chevron-up-icon]',
  template: `
    <svg:path
      d="M7.53125 5.5625L7.64062 5.48438L7.75 5.42188L7.875 5.39062L8 5.375L8.125 5.39062L8.25 5.42188L8.35938 5.48438L8.46875 5.5625L12.4531 9.54688L12.5156 9.65625L12.5625 9.78125L12.5938 9.90625V10.0312L12.5625 10.1562L12.5156 10.2812L12.4531 10.3906L12.3594 10.4844L12.25 10.5469L12.125 10.5938L12 10.625H11.875L11.75 10.5938L11.625 10.5469L11.5156 10.4844L8 6.95312L4.48438 10.4844L4.375 10.5469L4.25 10.5938L4.125 10.625H4L3.875 10.5938L3.75 10.5469L3.64062 10.4844L3.54688 10.3906L3.48438 10.2812L3.4375 10.1562L3.40625 10.0312V9.90625L3.4375 9.78125L3.48438 9.65625L3.54688 9.54688L3.59375 9.5L7.53125 5.5625Z" />
  `,
  host: {
    '[attr.viewBox]': 'viewBox()',
    class: 'mib-icon-default-size fill-current transition-colors',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChevronUpIcon {
  readonly viewBox = input<string>('0 0 16 16');
}
